// extracted by mini-css-extract-plugin
module.exports = {"footer":"_20bsI","link":"_52SAm","tinyLink":"_3yTNw","linkIcon":"_13dZy"};